<template>
  <div class="container">
    <header class="header">
      <div class="logout"> {{ this.keycloakState.userName }}
        <DButton color="primary" label="Logout" @click="logout" style="margin-left: 16px;" />
      </div>
      <h2 style="color: black;">Dashboards</h2>
    </header>

    <main class="content">
      <ProgressDialog :loading="dashboardState.isLoading" loadingText="Loading dashboards..." />
      <div class="dashboard-list">
        <DashboardListItem v-for="dashboard in dashboardState.dashboardList" :key="dashboard.id" :item="dashboard" />
      </div>
    </main>
    <footer class="footerStyle">
      <div>© 2024 - HighQ</div>
    </footer>
  </div>
</template>

<script>
import DashboardListItem from '@components/DashboardListItem.vue'
import ProgressDialog from '@components/ui/ProgressDialog.vue'
import DButton from '@components/ui/DButton.vue'

export default {
  components: {
    DashboardListItem: DashboardListItem,
    ProgressDialog: ProgressDialog,
    DButton: DButton
  },
  name: "dashboards-list",
  inject: ['keycloakState', 'dashboardState'],
  data() {
    return {
      userName: undefined
    }
  },
  mounted() {
    this.setUserName()
    this.dashboardState.loadDashboardList()
  },
  methods: {
    logout() {
      this.keycloakState.instance.logout();
    },
    async setUserName() {
      if (this.keycloakState.instance) {
        const userInfo = await this.keycloakState.instance.loadUserInfo()
        this.keycloakState.userName = userInfo.name
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.dashboard-list {
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px;
}
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.content {
  flex-grow: 1;
  overflow-y: auto;
  background-color: #f5f5f5;
}

h1 {
  margin: 16px;
}

.logout {
  position: absolute;
  right: 16px;
  color: black;
  margin: 16px;
}

.footerStyle {
  background-color: #f5f5f5;
  color: black;
  padding: 16px;
  text-align: center;
  height: 50px;
}

.header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 46px 0 46px 0;
  background-color: #f5f5f5;
  color: black;
  height: 60px;
}
</style>

